export default __webpack_public_path__ + "static/media/dark-left-arrow-icon.17e52e49.svg";